/* eslint-disable jam3/no-sanitizer-with-danger */
import PropTypes from 'prop-types';
import React, {memo} from 'react';
import styled from 'styled-components';

const SpanStyled = styled.span`
  p {
    margin-bottom: 0 !important;
  }
`;

const ViewEditor = ({value, defaultValue}) => {
  return value ? (
    <SpanStyled dangerouslySetInnerHTML={{__html: value}}/>) : defaultValue;
};

export default memo(ViewEditor);

ViewEditor.propTypes = {
  value: PropTypes.any,
  defaultValue: PropTypes.string,
};

ViewEditor.defaultProps = {
  defaultValue: '-',
};

export const renderViewEditor = ({value, label}) => {
  return (<div className="flex-col">
    {label && <div className="font-bold text-base">{label}:</div>}
    <div dangerouslySetInnerHTML={{__html: value}}/>
  </div>);
};

export const renderHTMLCellViewEditor = (value) => {
  return (<span dangerouslySetInnerHTML={{__html: value}}/>);
};
